// Global three.js settings. Imported first (see main.ts) so they apply before
// any colour or material is created.
//
// Colour management is on: hex colours are read as sRGB, lighting is computed
// in linear space and the result is encoded back to sRGB on output. That is
// three's own default since r152; the viewer ran in the old r138 mode (no
// colour management, linear output, light intensities scaled by π) until the
// environment lighting went in, which needs the physical pipeline to behave.
//
// Tone mapping is for light that was computed. Materials that ignore lights
// carry a colour that is already the answer - the gizmo's red, a measure line,
// the hatch on a cut face, the view cube - and the curve shifts those (white
// came out 240, a 42 grey came out 11), so each of them is created with
// toneMapped: false. It has to be per material: three assigns toneMapped in
// the Material constructor, which shadows any default set on the prototype.
import * as THREE from 'three';

THREE.ColorManagement.enabled = true;

/**
 * Khronos PBR Neutral: a soft roll-off into the highlights instead of a hard
 * clip, which is what keeps a white model from blowing out - on the sample
 * engine it took 35% of the model's pixels off the ceiling.
 */
export function configureRenderer(renderer: THREE.WebGLRenderer): void {
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.NeutralToneMapping;
  renderer.toneMappingExposure = 1;
}
